export class ObjectHelper {
    public static RemoveEmptyProperties(obj : any) : any {
        Object.keys(obj).forEach(function(key) {
            (obj[key] && typeof obj[key] === 'object') && ObjectHelper.RemoveEmptyProperties(obj[key]) ||
            (obj[key] === '' || obj[key] === null) && delete obj[key]
          });
          return obj;
    }
}